import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

// Import translation files directly for better bundling
import deTranslations from './translations/de.json'
import enTranslations from './translations/en.json'

// Language detector configuration
const detectionOptions = {
    // Detection order
    order: ['localStorage', 'navigator', 'htmlTag'],

    // Keys to detect language from
    lookupLocalStorage: 'language',

    // Cache detected language
    caches: ['localStorage'],

    // Optional - exclude certain languages from detection
    excludeCacheFor: ['cimode'],

    // Check for the language change only on init
    checkWhitelist: true
}

i18n
    // Detect user language
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next
    .use(initReactI18next)
    // Initialize i18next
    .init({
        // Language detection options
        detection: detectionOptions,

        // Default language
        fallbackLng: 'de',

        // Allowed languages
        supportedLngs: ['de', 'en'],

        // Debug mode (disable in production)
        debug: process.env.NODE_ENV === 'development',

        // Interpolation options
        interpolation: {
            escapeValue: false, // React already escapes values
        },

        // Translation resources (embedded)
        resources: {
            de: {
                translation: deTranslations
            },
            en: {
                translation: enTranslations
            }
        },

        // Namespace options
        ns: 'translation',
        defaultNS: 'translation',

        // Key separator
        keySeparator: '.',

        // Nested separator
        nsSeparator: ':',

        // Return null on missing keys
        returnNull: false,

        // Return empty string for missing keys
        returnEmptyString: false,

        // Postprocess missing keys
        saveMissing: process.env.NODE_ENV === 'development',

        // React options
        react: {
            // Bind i18n to suspense
            useSuspense: false,
            // Default language to use for plurals
            defaultTransParent: 'div',
        }
    })

export default i18n
